import styled, { css } from "styled-components";
import { color, typeStyle, units } from "@m/alchemy-theme";
import { ArrowLeftIcon } from "../icons/ArrowLeftIcon";
import { Item } from "./MenuListItem.styled";
export const BackIcon = styled(ArrowLeftIcon) `
  position: absolute;
  top: 50%;
  left: 10px;
  line-height: 0;
  transform: translateY(-50%);
`;
// TODO: what is hasField? maybe sync with mode from MenuItemContext instead to change paddings?
export const BackOptionItem = styled(Item) `
  color: ${color("typeBody")};
  ${typeStyle("bodyM")}
  padding: ${`${units(1)} ${units(2)} ${units(1)}`};
  padding-left: ${units(4)};

  ${BackIcon} {
    left: 12px;
    color: ${color("brandPrimary", { palette: "interactiveNavigational" })};
  }

  ${({ hasField }) => hasField &&
    css `
      padding-left: ${units(5)};

      ${BackIcon} {
        left: 18px;
      }
    `};
`;
